var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14771 4.29297H3.5795H15.0339",
    stroke: "#FB0C51",
    strokeWidth: 1.43179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72728 4.29328V2.86148C5.72728 2.48175 5.87813 2.11756 6.14664 1.84905C6.41516 1.58054 6.77934 1.42969 7.15908 1.42969H10.0227C10.4024 1.42969 10.7666 1.58054 11.0351 1.84905C11.3036 2.11756 11.4545 2.48175 11.4545 2.86148V4.29328M13.6021 4.29328V14.3158C13.6021 14.6956 13.4513 15.0598 13.1828 15.3283C12.9143 15.5968 12.5501 15.7476 12.1704 15.7476H5.01138C4.63165 15.7476 4.26747 15.5968 3.99895 15.3283C3.73044 15.0598 3.57959 14.6956 3.57959 14.3158V4.29328H13.6021Z",
    stroke: "#FB0C51",
    strokeWidth: 1.43179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0225 7.875V12.1704",
    stroke: "#FB0C51",
    strokeWidth: 1.43179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15894 7.875V12.1704",
    stroke: "#FB0C51",
    strokeWidth: 1.43179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogDeleteIcon);
export default __webpack_public_path__ + "static/media/blogDeleteIcon.49970c7a2be5d3968f9e127c6f134d30.svg";
export { ForwardRef as ReactComponent };